const Status = ({ status, statusVisible }) => {

  if (statusVisible) {
    return (<section className="status visible">{status}</section>)
  } else {
    return (<section className="status">{status}</section>)
  }

}

export default Status

